import { ButtonRow, Button } from "cai-fusion";
import { ReactComponent as IconSpark } from "../../../../../images/icon-spark.svg"

const SiftOpportunityAICallout = ({onDismiss}) => {
    return (
        <div className="m-callout m-callout--temporary m-callout--ai l-mb-xs l-mt-xs">
            <IconSpark className="m-callout__icon svg-inject" />
            <div className="m-callout__content">
                <h4 className="m-callout__title">Since you last viewed this opportunity...</h4>
                <p className="m-callout__text">Jackson Lamb weighed in, noting that we don't have any experience with the technologies required for this engagement. Diana countered that they are similar to technologies we've leveraged and we could always lean on sub-contractors to bring in experienced team members. The PDC Owner was changed to River Cartwright.</p>
            </div>
            <div className="m-callout__action">
                <ButtonRow>
                    <Button 
                        children="Dismiss"
                        onClick={onDismiss}
                    />
                </ButtonRow>
            </div>
        </div>
    );
}

export default SiftOpportunityAICallout;